export default function FieldLabel({ label, className = "" }) {
  return <label className={className}>{label} </label>;
}
